export const schemas = {
  portada: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Heuristiko",
    alternateName: "Heuristiko Software",
    url: "https://www.heuristiko.com",
    logo: "https://www.heuristiko.com/images/logo.png",
    description:
      "Empresa de desarrollo de software a medida con método heurístico",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Madrid",
      addressCountry: "ES",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+34-900-123-456",
      contactType: "sales",
      email: "contacto@heuristiko.com",
      availableLanguage: "Spanish",
    },
    sameAs: [
      "https://linkedin.com/company/heuristiko",
      "https://github.com/heuristiko",
    ],
  },
  servicios: {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Software Development",
    provider: {
      "@type": "Organization",
      name: "Heuristiko",
    },
    areaServed: {
      "@type": "Country",
      name: "Spain",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Servicios de Desarrollo de Software",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Desarrollo Web",
            description: "Aplicaciones web modernas, responsivas y escalables",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Aplicaciones Móviles",
            description: "Apps nativas y multiplataforma con UX excepcional",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Inteligencia Artificial",
            description: "Soluciones de IA y Machine Learning avanzadas",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Consultoría IT",
            description: "Asesoramiento experto para transformación digital",
          },
        },
      ],
    },
  },
  nosotros: {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    mainEntity: {
      "@type": "Organization",
      name: "Heuristiko",
      foundingDate: "2009",
      numberOfEmployees: {
        "@type": "QuantitativeValue",
        value: 15,
      },
      description:
        "Empresa especializada en desarrollo de software a medida usando método heurístico",
      knowsAbout: [
        "Desarrollo de Software",
        "Método Heurístico",
        "Inteligencia Artificial",
        "Transformación Digital",
      ],
      slogan: "Innovación a través del Método Heurístico",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        reviewCount: "50",
      },
    },
  },
  contacto: {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    mainEntity: {
      "@type": "Organization",
      name: "Heuristiko",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+34-900-123-456",
      email: "contacto@heuristiko.com",
      contactType: "customer service",
      areaServed: "ES",
      availableLanguage: "Spanish",
      contactOption: ["TollFree"],
      hoursAvailable: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "18:00",
      },
    },
  },
  tecnologias: {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Tecnologías que utilizamos",
    description: "Stack tecnológico de Heuristiko",
    numberOfItems: 30,
    itemListElement: [
      {
        "@type": "SoftwareApplication",
        position: 1,
        name: "React JS",
        applicationCategory: "Frontend Framework",
      },
      {
        "@type": "SoftwareApplication",
        position: 2,
        name: "Python",
        applicationCategory: "Programming Language",
      },
      {
        "@type": "SoftwareApplication",
        position: 3,
        name: "Docker",
        applicationCategory: "DevOps Tool",
      },
    ],
  },
  iacomparacion: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "¿Qué es el método heurístico?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "El método heurístico es un enfoque de resolución de problemas que utiliza técnicas prácticas para encontrar soluciones eficientes.",
        },
      },
      {
        "@type": "Question",
        name: "¿Cuánto tiempo toma desarrollar un software a medida?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "El tiempo de desarrollo varía según la complejidad, pero típicamente entre 3-6 meses para proyectos medianos.",
        },
      },
    ],
  },
};
